import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import vuetify from "./plugins/vuetify";
import ICS from "ics";
import "babel-polyfill";

Vue.use(ICS);
const moment = require("moment");
require("moment/locale/de");
Vue.use(require("vue-moment"), {
  moment,
});
Vue.prototype.moment = moment;
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
